import React, { FC } from 'react';

import { ButtonProps } from '@lglp/components';
import { Cta } from '@lglp/prismic-client';

import { default as LinkComponent } from '../../components/library/Link';
import CommonButton from '../CommonButton/CommonButton';
import CTAArrow from '../Icons/CTAArrow';
import styles from './CTAButton.module.scss';

export const CTAButton: FC<CTAButtonProps> = ({
  cta,
  revert = false,
  className,
  ...rest
}) => {
  return (
    <CommonButton
      as={LinkComponent}
      className={[
        styles.cta,
        'animate-svg',
        revert && styles.reverted,
        className,
      ]}
      label={cta.label}
      svg={CTAArrow}
      {...cta.link}
      {...rest}
    />
  );
};

type CTAButtonProps = ButtonProps & {
  cta: Cta;
  revert?: boolean;
};
